import { render } from "./SearchResultList.vue?vue&type=template&id=f2807432&scoped=true"
import script from "./SearchResultList.vue?vue&type=script&lang=js"
export * from "./SearchResultList.vue?vue&type=script&lang=js"

import "./SearchResultList.vue?vue&type=style&index=0&id=f2807432&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2807432"]])

export default __exports__